'use client'

import { faCaretUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect } from 'react'

export default function BackToTop() {
  const toggleVisible = () => {
    const scrolled = document.getElementById('toTop')

    if (window.scrollY > 300) {
      scrolled?.classList.remove('hidden')
      scrolled?.classList.add('block')
    } else if (window.scrollY <= 300) {
      scrolled?.classList.remove('block')
      scrolled?.classList.add('hidden')
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    window.addEventListener('scroll', toggleVisible)
  }, [])

  return (
    <div className="fixed right-5 top-[85%] z-90">
      <button
        id="toTop"
        onClick={scrollToTop}
        title="Go To Top"
        className="fixed bottom-8 right-8 z-90 hidden h-7 w-8 rounded-none border-0 bg-black text-sm font-bold text-white opacity-50 drop-shadow-md"
      >
        <FontAwesomeIcon icon={faCaretUp} className="h-5 w-3 pt-1" />
      </button>
    </div>
  )
}
